<div class="price-candidates-panel" (click)="$event.stopPropagation()">
  <div class="panel-header">
    <span class="panel-title">{{ 'quotations_and_orders.other_known_prices' | translate }}</span>
    <button class="panel-close" (click)="onClose($event)" aria-label="close">
      <ui-svg-icon svgIcon="close" size="small"></ui-svg-icon>
    </button>
  </div>

  <div class="panel-body" *ngIf="hasCandidates; else noCandidates">
    <ng-container *ngFor="let row of rows; trackBy: trackByRow">
      <div
        class="panel-candidate"
        [class.candidate-expired]="row.expired"
        [class.candidate-current]="row.current"
      >
        <span class="panel-candidate-source">
          <span class="candidate-source">{{ row.sourceKey | translate }}</span>
          <span class="candidate-freshness" [ngClass]="'freshness-' + row.freshness">
            {{ row.freshnessKey | translate }}
          </span>
        </span>
        <span class="candidate-value">{{ row.priceLabel }}</span>
        <button
          *ngIf="!isReadOnly && !row.expired"
          class="apply-btn"
          (click)="onApply($event, row)"
        >
          <ui-svg-icon svgIcon="rollback" size="small"></ui-svg-icon>
          {{ 'common.apply' | translate | uppercase }}
        </button>
      </div>
      <div
        class="panel-candidate-meta"
        *ngIf="row.evidenceKey || row.audienceKey || row.candidate.observed_at || row.candidate.valid_until || row.provenance || row.occurrences"
      >
        <span class="candidate-evidence" *ngIf="row.evidenceKey">{{ row.evidenceKey | translate }}</span>
        <span class="candidate-audience" *ngIf="row.audienceKey">{{ row.audienceKey | translate }}</span>
        <span class="candidate-occurrences" *ngIf="row.occurrences">{{ row.occurrences }}</span>
        <span class="candidate-date" *ngIf="row.candidate.observed_at">
          {{ row.candidate.observed_at | date: DATE_FORMAT }}
        </span>
        <span class="candidate-valid-until" *ngIf="row.candidate.valid_until">
          {{ 'quotations_and_orders.price_valid_until' | translate }}
          {{ row.candidate.valid_until | date: DATE_FORMAT }}
        </span>
        <!-- The provenance NAMES the file; when the file was kept, the eye
             beside it opens it. An imported tariff is the only source that
             has one. -->
        <span class="candidate-provenance" *ngIf="row.provenance">{{ row.provenance }}</span>
        <button
          *ngIf="row.provenance && row.documentId"
          type="button"
          class="preview-icon"
          [matTooltip]="'common.preview' | translate"
          matTooltipPosition="above"
          [attr.aria-label]="'common.preview' | translate"
          (click)="onPreviewSource($event, row)"
        >
          <ui-svg-icon svgIcon="eye" size="small"></ui-svg-icon>
        </button>
      </div>
    </ng-container>
  </div>

  <!-- "No known price" is not "the price is nothing": the empty state of a
       candidate list and the `none` price type are two different statements,
       each with its own key. -->
  <ng-template #noCandidates>
    <div class="panel-empty">{{ 'quotations_and_orders.no_known_prices' | translate }}</div>
  </ng-template>

  <!-- The APPLY buttons are gone because the server refuses pricing on this
       order, not because nothing is applicable. -->
  <div class="panel-locked" *ngIf="noPriceLocked">
    {{ 'quotations_and_orders.no_price_order_locked_hint' | translate }}
  </div>

  <!-- Rebuilt from the structured half of the trace; `decided_by` is a server
       diagnostic and stays in the logs. -->
  <div class="panel-why" *ngIf="why">
    <span class="why-label">{{ 'quotations_and_orders.why_this_price' | translate }}</span>
    <span class="why-value">{{ why!.key | translate: why!.params }}</span>
  </div>

  <!-- The guard rail of the direct capture: when the engine's own selection
       differs from the number on the line, say so and offer to apply it —
       this line only, never the whole order. -->
  <div class="panel-why panel-settings-preferred" *ngIf="settingsPreferred">
    <span class="why-label">{{ 'quotations_and_orders.per_your_settings' | translate }}</span>
    <span class="why-value">
      {{ settingsPreferred!.sourceKey | translate }} {{ settingsPreferred!.priceLabel }}
    </span>
    <button
      *ngIf="!isReadOnly"
      class="apply-btn"
      (click)="onApplySettingsPreferred($event)"
    >
      <ui-svg-icon svgIcon="rollback" size="small"></ui-svg-icon>
      {{ 'common.apply' | translate | uppercase }}
    </button>
  </div>
</div>
